import { useToast } from '@chakra-ui/react';
import { DropResult, showToast } from '@diamond/shared/ui';
import { useAuthStore } from '@diamond/sol-admin/features/auth';
import { useCallback } from 'react';

import { reorderVoucher } from '../api';
import { VOUCHER_TOAST_MESSAGES } from '../constants';

interface UseVoucherActionsProps {
  invalidateQueries: () => void;
}

export const useVoucherActions = ({
  invalidateQueries,
}: UseVoucherActionsProps) => {
  const session = useAuthStore();
  const toast = useToast();

  const handleIndexChange = useCallback(
    (result: DropResult) => {
      if (result.destination) {
        reorderVoucher(
          session.access_token,
          result.draggableId,
          result.destination.index
        ).then(() => {
          invalidateQueries();
        });
      }
    },
    [session.access_token, invalidateQueries]
  );

  const handleMoveToTop = useCallback(
    (id: string) => {
      reorderVoucher(session.access_token, id, 0)
        .then(() => {
          invalidateQueries();
          showToast(toast, 'success', VOUCHER_TOAST_MESSAGES.moveToTopSuccess);
        })
        .catch((error) => {
          showToast(
            toast,
            'error',
            VOUCHER_TOAST_MESSAGES.moveToTopError(error.message)
          );
        });
    },
    [session.access_token, toast, invalidateQueries]
  );

  return {
    handleIndexChange,
    handleMoveToTop,
  };
};
